import React from 'react';
import Dialog from '@mui/material/Dialog';
import { useTranslation } from 'react-i18next';
import { Alert, Button, DialogActions, DialogContent, DialogTitle, styled } from '@mui/material';

import { RESOURCES_KEYS } from 'utils/i18n/resources';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
    width: 600,
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

interface IDialogAlertMessageProps {
  isOpenDialogAlert: boolean;
  apiErrorTypeOrDetail?: string;
  onClose: () => void;
}

const DialogAlertMessage: React.FunctionComponent<IDialogAlertMessageProps> = ({
  apiErrorTypeOrDetail,
  isOpenDialogAlert,
  onClose,
}) => {
  const { t: translate } = useTranslation();

  return (
    <BootstrapDialog
      open={isOpenDialogAlert}
      disableEscapeKeyDown
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'>
      <DialogTitle id='alert-dialog-title'>{translate(RESOURCES_KEYS.API_ERROR_AN_ERROR_HAS_OCCURRED)}</DialogTitle>
      <DialogContent>
        {apiErrorTypeOrDetail && (
          <Alert sx={{ margin: '1rem 0' }} severity='error'>
            {translate(apiErrorTypeOrDetail)}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} autoFocus>
          {translate(RESOURCES_KEYS.CLOSE)}
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default DialogAlertMessage;
